var Utils = require("./utils");
var queryArray = Utils.queryArray;

var navButton = document.querySelector("a.page-nav-button");
var closeNavButton = document.querySelector("a.page-nav-close-button");
var navButtonWrapper = document.querySelector(".page-nav-button-wrapper");
var nav = document.querySelector("nav.page-nav");

if (navButton) {
  navButton.addEventListener("click", function() {
    nav.classList.add("active");
  });
}
if (closeNavButton) {
  closeNavButton.addEventListener("click", function() {
    nav.classList.remove("active");
  });
}
if (navButtonWrapper) {
  window.addEventListener("scroll", function() {
    if (window.pageYOffset > 600) {
      navButtonWrapper.classList.remove("hidden");
    } else {
      navButtonWrapper.classList.add("hidden");
      nav.classList.remove("active");
    }
  });
}

if (document.location.pathname == "/resources/sustainability-resources") {
  // pull link from last li in secondary nav
  var additionalResourcesLink = document.createElement("a");
  additionalResourcesLink.href = "#additional-resources";
  additionalResourcesLink.innerHTML = "Additional Resources";

  // add link to the new last li in secondary nav
  var additionalResourcesList = document.querySelector(
    ".page-nav ul li:last-child"
  );
  additionalResourcesList.appendChild(additionalResourcesLink);
}
